import styled from "styled-components";


export const ModalContainerStyled = styled.div`
    position: fixed;
    inset: 0; 
    background-color: rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(6px); 
    -webkit-backdrop-filter: blur(6px);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    z-index: 9999999;

`;

// On small screens align modal to top so content isn't hidden under browser UI
export const ModalContainerMobile = styled(ModalContainerStyled)`
    @media only screen and (max-width: 991px) {
        align-items: flex-start;
        padding-top: env(safe-area-inset-top, 12px);
    }
`;

export const ModalStyled = styled.div`
    background: rgba(12, 30, 40, 0.75);
    width: 100%;
    color: #fff;
    max-height: 100vh;
    padding: 2rem;
    margin-top: 1rem;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    h2{
        font-size: 1.2rem;
        margin: 1rem auto;
    }
    .plans{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 1rem;
        height: fit-content;
        overflow: auto;
        scrollbar-width: none;       
        -ms-overflow-style: none;
        .header{
            display: flex;
            flex-direction: column;
            justify-content: center;
            h3{
                align-self: center;
            }
            .firstColumn{
                display: flex;
                justify-content: space-between;
                .price{
                    p{
                        text-align: right;
                        font-size: 2rem;
                    }
                    div{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        gap: 0.5rem;
                        .discount{
                            span{
                                color: #5fbec5;
                                font-size: 1rem;
                            }
                        }
                        p{
                            font-size: 1rem;
                        }
                        .strikethrough{
                            font-size: 1.2rem;
                            text-decoration: line-through;
                            
                        }
                        
                    }
                }
            }
            .ratings{
                display: flex;
                gap: 0.8rem;
            }
        }
        .planContainerMonth{
            display: flex;
            flex-direction: column;
            gap:0.7rem;
            border-radius: 0.625rem;
            background: rgba(12, 30, 40, 1);
            border: 1px solid #5fbec5;
            width: 100%;
            height: fit-content;
            padding: 0.5rem;
            .button{
                display: flex;
                justify-content: center;
                font-weight: 300;
                width: 90%;
                text-align: center;
                margin: 1rem auto;
                align-items: center;
            }

            .featureContainer{
                background: #fff;
                border-radius: 0.625rem;

                .feature {
                    display: flex;
                    padding: 0.5rem 0 0 0.5rem;
                    gap: 0.7rem;
                    align-items: start;
                    font-weight: 300;
                    color: rgba(12, 30, 40, 1);
                }
            }
            .header{
                color: #fff;
                h3{
                    text-align: left;
                    font-size: 1.2rem;
                    font-weight: 300;
                }
                p{
                    text-align: left;
                    font-size: 1rem;
                }
            }
        
        }
        .planContainer{
            display: flex;
            flex-direction: column;
            gap:0.7rem;
            border-radius: 0.625rem;
            border: 1px solid #5fbec5;
            background: #fff;
            width: 100%;
            height: fit-content;
            padding: 0.5rem;
           .button{
               display: flex;
               justify-content: center;
               font-weight: 300;
               width: 90%;
               text-align: center;
               margin: 1rem auto;
               align-items: center;
           }

            .featureContainer{
                background: rgba(12, 30, 40, 1);
                border-radius: 0.625rem;

                .feature {
                    display: flex;
                    padding: 0.5rem 0 0 0.5rem;
                    gap: 0.7rem;
                    align-items: start;
                    font-weight: 300;
                }
            } 
            .header{
                color: #1e1e1e;
                h3{
                    text-align: left;
                    font-size: 1.2rem;
                    font-weight: 300;
                }
                p{
                    text-align: left;
                    font-size: 1rem;
                }
            }
        }
    }
    .cancel-mobile{
        width: fit-content;
        color: #fff;
        margin: 0 auto 4rem auto;
        background: none;
        font-size: 1.2rem;
        border: none;
        text-decoration: underline;
        cursor: pointer;
        &:hover{
            text-decoration: none;
        }
    }
    .cancel-desktop{
        display: ${({$mobile})=> $mobile === "true" && 'none'};
    }
    @media only screen and (min-width: 992px) {
        margin-top: 0;

        h2{
            font-size: 1.2rem;
        }
        .plans {
            flex-direction: row;
            justify-content: space-evenly;
            gap: 1rem;
            height: fit-content;
            .planContainerMonth {
                .header {

                    h3 {
                        font-size: 1.2rem;
                    }

                    p {
                        font-size: 1.2rem;
                    }
                }
            }

            .planContainer {
               

                .header {
                    
                    h3 {
                        font-size: 1.2rem;
                    }

                    p {
                        font-size: 1.2rem;
                    }
                }
            }
        }
        .cancel-desktop{
            display: flex;
            width: fit-content;
            color: #fff;
            margin: 0 auto;
            font-size: 1.2rem;
            background: none;
            border: none;
            cursor: pointer;
            text-decoration: underline;

            &:hover{
                text-decoration: none;
            }
        }
        .cancel-mobile{
            display: ${({$mobile})=> $mobile === "true" && 'none'};
        }
    }

`

export const CheckoutModalStyled = styled.div`
    background-color: #000000eb;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 999999;
    overflow-y: scroll;
    padding: 50px 0;
    
    .section {
        display: flex;
        flex-direction: column-reverse;
        gap: 1.5rem;
        width: 100%;
        .media {
            width: 100%;
            .refundText {
                display: flex;
                flex-direction: column;
                h5 {
                    margin: 0!important;
                    font-size: 1.5rem!important;
                }

                h2 {
                    font-size: 2rem!important;
                    margin: 0!important;
                }
            }
        }
        .info{
            width: 100%;
            .infoContainer{
                display: flex;
                flex-direction: column;
                padding: 1rem;
                width: 100%;
                gap: 0.7rem;
                border: .02rem solid #ccc;
                height: 460px;
                box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
                border-radius: 0.625rem;
                h5{
                    align-self: start;
                    font-size: 1rem!important;
                }
                .group{
                    display: flex;
                    flex-direction: column;
                    gap: 0.6rem;
                    .groupItems{
                        display: flex;
                        justify-content: space-between;
                        font-weight: 300;
                    }
                }
                .couponContainer{
                    display: flex;
                    background: rgba(153, 153, 153, 0.23);
                    border: 0.6px solid #000;
                    border-radius: 1rem;
                    justify-content: space-between;
                    padding: 0 0.6rem;
                    align-items: center;
                }
            }
        }
    }
    @media only screen and (min-width: 992px) {
        .section {
            flex-direction: row;
            gap: 0.6rem;
            .media {
                width: 40%;
            }
            .info {
                width: 60%;
                .infoContainer{
                    h5{
                        align-self: start;
                        font-size: 1rem;
                    }
                    
            }
        }
    }
`

export const ModalMainStyled = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(6px); /* 🔹 Blur background */
    background: rgba(0, 0, 0, 0.4); /* 🔹 Semi-transparent dark overlay */
    z-index: 1000; /* 🔹 Make sure it sits above other content */

    .modal-content {
        background: ${({theme}) => (theme === "dark" ? "#1e1e1e" : "#fff")};
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.6rem;
        padding: 1rem;
        border-radius: 12px;
        max-width: 500px;
        width: ${({width})=> width || '90%'};
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        text-align: center;

        .cancel {
            align-self: end;
        }
    }

`